export default __webpack_public_path__ + "static/media/h2.dd003ef3.png";